module.exports = __webpack_public_path__ + "img/us.8cd96243.png";